import { paraDefaultPathForRole } from '@para/shared/para-default-route.util';

/** Post-login / unauthorized redirect target from JWT role. */
export function defaultPathForJwtRole(role: string | undefined): string {
	return paraDefaultPathForRole(role);
}
